var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 535,
    height: 350,
    viewBox: "0 0 535 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5f5f2",
    stopOpacity: 0.827
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rechteck_14816",
    x: 0,
    y: 0,
    width: 535,
    height: 350,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#02332a",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40760",
    "data-name": "Gruppe 40760",
    transform: "translate(-8806.5 257.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 8806.5, -257.5)",
    filter: "url(#Rechteck_14816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_14816-2",
    "data-name": "Rechteck 14816",
    transform: "translate(148.5 98.5)",
    stroke: "#fcfcfc",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 53,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 236,
    height: 51,
    rx: 13,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Pers\\xF6nlicher_Ern\\xE4hrungsplan",
    "data-name": "Pers\\xF6nlicher  Ern\\xE4hrungsplan",
    transform: "translate(9034 -136)",
    fill: "#142c1f",
    fontSize: 14,
    fontFamily: "Rubik-Regular, Rubik"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pers\xF6nlicher "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "Ern\xE4hrungsplan")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\uD83C\\uDF4E",
    transform: "translate(8965 -155.764)",
    fill: "#707070",
    fontSize: 35,
    fontFamily: "AppleColorEmoji, Apple Color Emoji"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 35
  }, "\uD83C\uDF4E")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.9328f06d7ca65f0515f2f711efcb94e0.svg";
export { ForwardRef as ReactComponent };